export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.29-1705.16",
  commitId: "e8b39c1c83d41f719c3691cce4cc113b8592f1eb",
  commitTime: "2026-07-29T17:05:16.000Z",
});
